import * as React from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider as ThemeMUIProvider } from "@mui/material/styles";
import { theme } from "../../../common/theme";

const ThemeProvider = ({ children }: { children?: React.ReactNode }) => (
  <ThemeMUIProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeMUIProvider>
);

export default ThemeProvider;
